if (!customElements.get('upsell-tabs')) {
  class UpsellTabs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (e) => {
        const value = e.target.value;
        this.querySelectorAll('[data-tab-content]').forEach((panel) => {
          const active = panel.dataset.tabContent === value;
          panel.classList.toggle('opacity-100', active);
          panel.classList.toggle('opacity-0', !active);
          panel.classList.toggle('pointer-events-none', !active);
        });
      });
    }
  }

  customElements.define('upsell-tabs', UpsellTabs);
}
